import { render, staticRenderFns } from "./Evaluaciones.vue?vue&type=template&id=bad90f48&scoped=true"
import script from "./Evaluaciones.vue?vue&type=script&lang=js"
export * from "./Evaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad90f48",
  null
  
)

export default component.exports